import { render, staticRenderFns } from "./ModifyThresHoldDetectionPopup.vue?vue&type=template&id=391e58af&"
import script from "./ModifyThresHoldDetectionPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyThresHoldDetectionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports